import type { IIdToLoaderData } from 'cms/loaders';

import type { PictureSourceSpec } from './pictures';

export type FontPreload = {
  href: string;
  as: 'font';
  type: 'font/woff2';
  crossOrigin: 'anonymous';
};

export const CONTENT_PAGE_FONT_PRELOADS: ReadonlyArray<FontPreload> = [
  {
    href: '/fonts/graphik-regular/Graphik-Regular.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous',
  },
  {
    href: '/fonts/graphik-medium/Graphik-Medium.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous',
  },
  {
    href: '/fonts/graphik-semibold/Graphik-Semibold.woff2',
    as: 'font',
    type: 'font/woff2',
    crossOrigin: 'anonymous',
  },
];

const isPictureSource = (value: unknown): value is PictureSourceSpec[number] => {
  if (!value || typeof value !== 'object') return false;
  const source = value as Partial<PictureSourceSpec[number]>;
  return (
    typeof source.key === 'string' &&
    typeof source.srcSet === 'string' &&
    typeof source.media === 'string' &&
    (source.fallbackSrc === undefined || typeof source.fallbackSrc === 'string')
  );
};

export const getContentPageImagePreloads = (idToLoaderData: IIdToLoaderData): PictureSourceSpec =>
  Object.values(idToLoaderData)
    .flatMap((loaderData) =>
      Array.isArray(loaderData?.preloadImages) ? loaderData.preloadImages : [],
    )
    .filter(isPictureSource);
